/**
 * @override King Living: Header 2.0 column-by-id + FullMenuItem L3.
 * Menu Image Gallery on each Link — load the CMS collection (no Header 2.0
 * image cap). Header 1.0 must keep NavigationColumnFragment (links only).
 * Do not spread generated LinkFragment (gallery + cursor, no bound → complexity 400).
 */

import gql from 'graphql-tag';

import {BaseNavigationColumnFragment} from '@amblique/contentful/app/contentful/fragments/navigation-column/base-navigation-column.fragment';
import {BaseLinkFragment} from '@amblique/king-living/app/contentful/fragments/link/base-link.fragment';
import {BaseImageFragment} from '@amblique/king-living/app/contentful/fragments/image/base-image.fragment';

export const FullNavigationColumnFragment = gql`
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseNavigationColumnFragment}

  fragment FullNavigationColumnFragment on NavigationColumn {
    ...BaseNavigationColumnFragment

    linksCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
          menuImageGalleryCollection {
            items {
              __typename
              ... on Image {
                ...BaseImageFragment
              }
            }
          }
        }
      }
    }
    linksCursorCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
          menuImageGalleryCollection {
            items {
              __typename
              ... on Image {
                ...BaseImageFragment
              }
            }
          }
        }
      }
    }
  }
`;
